/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

const style = { display: 'inline-block', verticalAlign: 'middle', marginBottom: '5px' }

export const CreditCardInfoIcon = ({ onClick }) => (
  <span onClick={onClick}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M7.99983 14.6668C11.6817 14.6668 14.6665 11.682
        14.6665 8.0001C14.6665 4.3182 11.6817 1.33344 7.99983
        1.33344C4.31793 1.33344 1.33316 4.3182 1.33316 8.0001C1.33316
        11.682 4.31793 14.6668 7.99983 14.6668Z"
        stroke="#3E3E47"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 10.6667V8" stroke="#3E3E47" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 5.33344H8.005" stroke="#3E3E47" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
)
